import React, { useEffect } from 'react';
import { useParams, useNavigate, Navigate } from 'react-router-dom';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import { LEGAL_DOCS, LEGAL_INDEX, LEGAL_UPDATED } from './legalDocs';

export default function LegalPage() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const doc = LEGAL_DOCS[slug];

  useEffect(() => { window.scrollTo(0, 0); }, [slug]);

  if (!doc) return <Navigate to="/" replace />;

  return (
    <div className="min-h-screen bg-gray-50"><Navbar />
      <div className="max-w-3xl mx-auto px-6 pt-24 pb-16">
        <button onClick={() => navigate(-1)}
          className="text-sm text-gray-400 hover:text-blue-700 transition mb-4">← Geri</button>

        <h1 className="text-2xl font-bold text-gray-900 mb-1">{doc.title}</h1>
        <p className="text-xs text-gray-400 mb-6">Son güncelleme: {LEGAL_UPDATED}</p>

        {doc.intro?.map((t, i) => (
          <p key={i} className="text-sm text-gray-600 leading-relaxed mb-3">{t}</p>
        ))}

        {doc.sections.map((s, i) => (
          <section key={i} className="mt-6">
            <h2 className="text-base font-bold text-gray-800 mb-2">{s.h}</h2>
            {s.p?.map((t, j) => (
              <p key={j} className="text-sm text-gray-600 leading-relaxed mb-2">{t}</p>
            ))}
            {s.list && (
              <ul className="list-disc pl-5 space-y-1.5 text-sm text-gray-600">
                {s.list.map((t, j) => <li key={j}>{t}</li>)}
              </ul>
            )}
          </section>
        ))}

        <div className="mt-10 pt-6 border-t border-gray-200">
          <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-3">Diğer Yasal Metinler</p>
          <div className="flex flex-wrap gap-2">
            {LEGAL_INDEX.filter(d => d.slug !== slug).map(d => (
              <button key={d.slug} onClick={() => navigate(`/yasal/${d.slug}`)}
                className="text-xs border border-gray-200 rounded-lg px-3 py-1.5 text-gray-600 hover:border-blue-400 hover:text-blue-700 transition">
                {d.label}
              </button>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
